export type RuntimeRegion = 'cn' | 'global';

export interface RuntimeCapabilities {
  region: RuntimeRegion;
  providerFinance: boolean;
}

export function resolveRuntimeCapabilities(
  rawRegion: string | undefined
): RuntimeCapabilities {
  const region = rawRegion;
  if (region !== 'cn' && region !== 'global') {
    throw new Error(`Unsupported VITE_DORA_REGION: ${region || 'missing'}`);
  }
  return {
    region,
    providerFinance: region === 'cn',
  };
}

export const runtimeCapabilities = resolveRuntimeCapabilities(
  import.meta.env.VITE_DORA_REGION
);
